import { BaseEnum } from "../../../../enums/baseEnum";

const listEthicsChannelReportInvestigation: Array<EthicsChannelReportInvestigation> =
  [];

export class EthicsChannelReportInvestigation extends BaseEnum {
  static PROCEEDING = new EthicsChannelReportInvestigation(
    1,
    "PROCEEDING",
    "Procedente"
  );
  static UNFOUNDED = new EthicsChannelReportInvestigation(
    2,
    "UNFOUNDED",
    "Não Procedente"
  );

  constructor(public id: number, public value: string, public label: string) {
    super(id, value, label);
    listEthicsChannelReportInvestigation.push(this);
  }

  public static buildListEnum(): Array<BaseEnum> {
    return listEthicsChannelReportInvestigation;
  }

  public static getBy(value: string): EthicsChannelReportInvestigation {
    return listEthicsChannelReportInvestigation.find(
      (p: EthicsChannelReportInvestigation) => p.value === value
    );
  }

  public static getById(id: number): EthicsChannelReportInvestigation {
    return listEthicsChannelReportInvestigation.find(
      (p: EthicsChannelReportInvestigation) => p.id === id
    );
  }
}
